// ログイン画面（メール認証リンク方式）。
// 登録済みメンバーがメアドを入力 → ワンタイムURLが届く → クリックでログイン完了。
// パスワードは無い（＝忘れる・使い回す・共有される、が起きない）。

import React, { useState } from "react";
import logo from "../assets/hsd-logo.png";
import { Ic } from "../components/Icons";
import { requestLogin } from "../lib/authApi";

// expired … メールのログインリンクが切れていた（/?login=expired）
// sessionExpired … 作業中にログイン状態（30日）が切れた。作業内容はこの端末に残っていることを伝える
export function LoginScreen({ expired, sessionExpired }: { expired?: boolean; sessionExpired?: boolean }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const addr = email.trim();
    if (!addr) return;
    setSending(true);
    setError(null);
    // 携帯の届出フォームからログインした場合は、そのフォームへ戻す
    const isEntry = new URLSearchParams(window.location.search).get("entry") === "1";
    const r = await requestLogin(addr, isEntry ? "/?entry=1" : undefined);
    setSending(false);
    if (r.ok) setSent(true);
    else setError(r.error || "送信に失敗しました");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eef0f4",
        padding: 20,
      }}
    >
      <div className="card" style={{ width: "100%", maxWidth: 440, padding: "30px 30px 26px" }}>
        <div className="row gap-8" style={{ alignItems: "center", marginBottom: 18 }}>
          <div className="brand-plate" style={{ border: "1px solid #e3e6ec", padding: "7px 11px" }}>
            <img src={logo} alt="HS-deliverys" />
          </div>
          <div className="col gap-4">
            <div style={{ fontWeight: 800, fontSize: 15 }}>HSD月次処理</div>
            <div className="tiny muted">株式会社HS-deliverys 委託料の月次処理</div>
          </div>
        </div>

        {sessionExpired && !sent && (
          <div className="toast warn" style={{ marginBottom: 14 }}>
            <Ic.alert size={14} />
            <div className="col gap-4">
              <b>ログインの有効期限（30日）が切れました</b>
              <div className="tiny">
                作業中の内容はこの端末に残っています。もう一度ログインすると、共有への保存を再開します。
                ログイン後に「共有されている内容と、この端末の内容が違います」と出た場合は、新しい方を選んでください。
              </div>
            </div>
          </div>
        )}
        {expired && !sessionExpired && !sent && (
          <div className="toast warn" style={{ marginBottom: 14 }}>
            <Ic.alert size={14} />
            <div className="col gap-4">
              <b>ログインリンクの有効期限が切れています</b>
              <div className="tiny">もう一度メールアドレスを入力して、新しいリンクをお受け取りください。</div>
            </div>
          </div>
        )}

        {sent ? (
          <>
            <div className="toast" style={{ background: "#e8f7ec", borderColor: "#a8dbb1", color: "#1d6b34" }}>
              <Ic.checkCircle size={15} />
              <div className="col gap-4">
                <b>ログイン用のメールを送信しました</b>
                <div className="tiny">
                  {email} 宛に届いたメールの「ログインする」ボタンを押してください（15分間有効）。
                </div>
              </div>
            </div>
            <div className="tiny muted" style={{ marginTop: 14, lineHeight: 1.8 }}>
              メールが届かない場合：迷惑メールフォルダをご確認ください。それでも見当たらないときは、
              このアプリに登録されていないアドレスの可能性があります（管理者にご確認ください）。
            </div>
            <button className="btn" style={{ marginTop: 14 }} onClick={() => { setSent(false); setError(null); }}>
              <Ic.chevronL size={13} /> 別のアドレスで送り直す
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>メールアドレス</div>
            <input
              className="input"
              type="email"
              autoFocus
              required
              placeholder="you@example.co.jp"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", marginBottom: 12 }}
            />
            {error && (
              <div className="toast warn" style={{ marginBottom: 12 }}>
                <Ic.alert size={14} />
                <span className="tiny">{error}</span>
              </div>
            )}
            <button className="btn primary" type="submit" disabled={sending} style={{ width: "100%", justifyContent: "center" }}>
              <Ic.mail size={14} /> {sending ? "送信中..." : "ログイン用リンクをメールで受け取る"}
            </button>
            <div className="tiny muted" style={{ marginTop: 14, lineHeight: 1.8 }}>
              パスワードはありません。入力したアドレス宛にワンタイムのログインURLをお送りします。
              <br />
              このアプリに登録された方のみログインできます。
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
